import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-02jurassic_horizalign_right",
  "use": "icon-02jurassic_horizalign_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-02jurassic_horizalign_right\"><path d=\"M896 64h64v896h-64z\" fill=\"#727272\" /><path d=\"M320 192h512v256H320z\" fill=\"#B3B3B3\" /><path d=\"M64 576h768v256H64z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol